import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const registerDeviceSlice = createSlice({
  name: 'registerDevice',
  initialState,
  reducers: {}
});

export default registerDeviceSlice.reducer;
